import * as React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import i18n from 'modules/core/lib/i18n'

import DeleteCategoryModal from 'modules/attendance/components/CustomTimeRanges/Content/TimeCategoriesValues/Modals/DeleteCategory'
import EditCategoryModal from 'modules/attendance/components/CustomTimeRanges/Content/TimeCategoriesValues/Modals/EditCategoryModal'
import { CustomTimeRangeCategory } from 'modules/attendance/hooks/useFetchCustomTimeRangeCategories'

import CategoryTag from './Tag'

interface Props {
  category: CustomTimeRangeCategory
}

const CategoryCard = ({ category }: Props) => {
  const [deleteModalOpen, setDeleteModalOpen] = React.useState(false)
  const [editModalOpen, setEditModalOpen] = React.useState(false)

  return (
    <Box
      width="full"
      flexDirection="row"
      justifyContent="spaceBetween"
      paddingY="s16"
      paddingX="s24"
      alignItems="center"
      border={{
        all: {
          color: 'grey400',
          width: 's1',
          style: 'solid',
        },
      }}
      borderRadius={{
        all: 'abs008',
      }}
    >
      <Box gap="s6" flexDirection="row">
        <Text.Normal color="grey1000" weight="medium" ellipsis>
          {category.name}
        </Text.Normal>
        <CategoryTag category={category} />
      </Box>
      <Box paddingLeft="s8" alignItems="flexEnd">
        <PopoverMenu type="list">
          <Box alignItems="center" gap="s16" flexDirection="row" justifyContent="center">
            <Box>
              <Text size="200" whiteSpace="nowrap">
                {i18n.t('time_categories.card_description', {
                  rawMinutes: category.rawMinutes,
                  equivalentMinutes: category.equivalentMinutes,
                })}
              </Text>
            </Box>
            <PopoverMenu.Trigger>
              <Button.Decorative type="secondary" iconName="ellipsis-horizontal" />
            </PopoverMenu.Trigger>
          </Box>
          <PopoverMenu.Content side="bottom" align="end">
            <PopoverMenu.TouchableOption
              title={i18n.t('common.edit')}
              onClick={() => setEditModalOpen(true)}
            />
            <PopoverMenu.TouchableOption
              title={i18n.t('common.remove')}
              onClick={() => setDeleteModalOpen(true)}
              danger
            />
          </PopoverMenu.Content>
        </PopoverMenu>
      </Box>
      {editModalOpen && <EditCategoryModal setModalOpen={setEditModalOpen} category={category} />}
      {deleteModalOpen && (
        <DeleteCategoryModal category={category} setDeleteModalOpen={setDeleteModalOpen} />
      )}
    </Box>
  )
}

export default CategoryCard
